// extracted by mini-css-extract-plugin
module.exports = {"altHero":"xg","altProd":"yg","subheading":"zg","subtext":"Ag","extrainfo":"Bg","copy":"Cg","cta":"Dg","disabled":"Eg"};